import { AbstractControl } from '@angular/forms';

export class ValidateConfirmPassword {
  static MatchPassword(abstractControl: AbstractControl) {
    let password = abstractControl.get('Contrasena')?.value;
    let confirmPassword = abstractControl.get('confirmarContrasena')?.value;

    if (password != confirmPassword || confirmPassword != password) {
      abstractControl.get('confirmarContrasena')?.setErrors({
        MatchPassword: true,
      });
    } else {
      // return null;
      MatchPassword: false
    }
  }
}
